import ImportedProcedureUpdateCreateContainer from 'ImportedProcedureUpdateCreate/container/ImportedProcedureUpdateCreateContainer';

export default ImportedProcedureUpdateCreateContainer;
